import { HttpClient, HttpMethod, HttpResponse, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { GetSectionsInput } from '../domain/dtos/get-sections.dto'
import { Section } from '../domain/dtos/section.dto'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'

export class GetSections {
  public constructor(@inject(HttpClient) private readonly httpClient: HttpClient) {}

  public async execute(input: GetSectionsInput): Promise<Section[]> {
    const response: HttpResponse<any> = await this.httpClient.request({
      method: HttpMethod.GET,
      url: this.makeUrl(input),
    })

    if (response.statusCode === HttpStatusCode.OK) {
      return this.makeData(response)
    }

    throw new GeneralError()
  }

  private makeUrl(input: GetSectionsInput) {
    return `${Envs.BFF_MEMBERS_AREA_URL}/hub/sections/v2?productId=${input.productId}&page=1&pageSize=999&postPageSize=999`
  }

  private makeData(response: HttpResponse<any>) {
    return response.data?.items ?? []
  }
}
